<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Documents">
                          Documents
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Technical Specification</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:100vw">
            <div class="cntnt">

          <div id="">
            <b-row>
              <b-col cols="12">
                  <h1 class="heading">Standard Technical Specification</h1>

              </b-col>

           </b-row>
           <p class="content">
              <b-table responsive striped :items="techSpec" :fields="techSpecFields">

                <template v-slot:cell(link)="data">
                  <span   v-html="data.value"></span>
                </template>
              </b-table>
            </p>
          </div>

          </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
var headColor = '#ffff';
var textColor = '#424242';
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
export default {

  components: {
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    },
  data() {
      return {
        techSpecFields: [
          { key: 'sl_no', label: 'S/N',thStyle: {width: '5vw',backgroundColor:headColor,color:textColor,border:'solid #ffff 1px'} },
          { key: 'item_desc', label: 'Item Description',thStyle: {width: '40vw',backgroundColor:headColor,color:textColor,border:'solid #ffff 1px'} },
          { key: 'spec', label: 'Specification No',thStyle: {width: '40vw',backgroundColor:headColor,color:textColor,border:'solid #ffff 1px'} },
          { key: 'updated', label: 'Updated On',thStyle: {width: '10vw',backgroundColor:headColor,color:textColor,border:'solid #ffff 1px'} },
          { key: 'link', label: 'Download',thStyle: {width: '5w',backgroundColor:headColor,color:textColor,border:'solid #ffff 1px'} }
        ],
        techSpec : []

      }
  },
  computed:
  {

  },
  methods: {

  },
  mounted() {
    var parent = this;
    axios.get(this.$urlCommon + "/api/web/getTechSpecification").then(function(response) {
      console.log(response.data);
      var temp = [];
        response.data.techSpec.forEach(element => {
          var obj = {
          "sl_no":element.id,
          "item_desc":element.item_desc,
          "spec":element.spec_no,
          "updated":element.date,
          "link": "<a style='padding-left:30%' target='_blank' href='"+parent.$urlCommon +"/"+element.file_location+"'><img src='"+parent.$urlCommon+"/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
      }
      temp.push(obj)

  })
  console.log(temp)
  parent.techSpec = temp

    })

  }
}
</script>

<style scoped="true">
li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}

table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }

</style>
